// src/api/fish/fish.js
import request from '@/utils/request'

// ==================== 鱼类商品管理 ====================

// 获取鱼类商品列表（后台管理 - 支持分页、状态筛选、关键词搜索）
export const getFishProducts = (page, pageSize, status, keyword) => {
  return request.get('/fish/ht/fish/products', {  // 路径改为 /ht/fish/products
    params: {
      page: page,
      pageSize: pageSize,
      status: status,
      keyword: keyword
    }
  })
}

// 获取单个商品详情
export const getFishProductDetail = (id) => {
  return request.get('/fish/fish/product', {
    params: { id: id }
  })
}

// 添加商品
export const addFishProduct = (data) => {
  return request.post('/fish/fish/product', data)
}

// 更新商品
export const updateFishProduct = (id, data) => {
  return request.put('/fish/fish/product', { id: id, ...data })
}

// 删除/下架商品（soft=软删除/下架，hard=硬删除）
export const deleteFishProduct = (id, type = 'soft') => {
  return request.post('/fish/fish/product/delete', { id: id, type: type })
}

// 批量删除商品
export const batchDeleteFishProducts = (ids, type = 'soft') => {
  return request.post('/fish/fish/products/batchDelete', { ids: ids, type: type })
}

// 更新商品库存
export const updateFishProductStock = (id, stock) => {
  return request.post('/fish/fish/product/stock', { id: id, stock: stock })
}

export const uploadFishProductImage = (file, openid = 'houtai_admin') => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('openid', openid)
  formData.append('image_type', 'fish_product')
  return request.post('/pic/fishpic', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// ==================== 运费配置管理 ====================

// 获取运费配置
export const getShippingConfig = () => {
  return request.get('/fish/fish/shipping')
}

// 更新运费配置
export const updateShippingConfig = (data) => {
  return request.put('/fish/fish/shipping', data)
}

// ==================== 订单管理 ====================

// 获取订单列表
export const getOrders = (page, pageSize, status, keyword, startDate, endDate, userId) => {
  return request.get('/fish/ht/fish/orders', {
    params: {
      page: page,
      pageSize: pageSize,
      status: status,
      keyword: keyword,
      startDate: startDate,
      endDate: endDate,
      user_id: userId
    }
  })
}

// 获取订单详情
export const getOrderDetail = (id) => {
  return request.get('/fish/fish/order', {
    params: { id: id }
  })
}

// 更新订单状态
export const updateOrderStatus = (id, status) => {
  return request.put('/fish/fish/order/status', { id: id, status: status })
}

// 批量更新订单状态
export const batchUpdateOrderStatus = (ids, status) => {
  return request.post('/fish/fish/orders/batchStatus', { ids: ids, status: status })
}



// 确认订单（填写收货信息）
export const confirmOrder = (id, contact_name, contact_phone, shipping_address) => {
  return request.put('/fish/fish/order/confirm', {
    id: id,
    contact_name: contact_name,
    contact_phone: contact_phone,
    shipping_address: shipping_address,
    status: 1
  })
}

// 发货（填写快递单号）
export const shipOrder = (id, tracking_no) => {
  return request.put('/fish/fish/order/ship', {
    id: id,
    tracking_no: tracking_no,
    status: 2
  })
}





// 删除订单
export const deleteOrder = (id) => {
  return request.post('/fish/fish/order/delete', { id: id })
}

// 取消订单
export const cancelOrder = (id) => {
  return request.post(`/fish/fish/order/${id}/cancel`)
}

// 获取订单统计
export const getOrderStats = () => {
  return request.get('/fish/fish/orders/stats')
}

// 导出订单
export const exportOrders = (params) => {
  return request.get('/fish/fish/orders/export', {
    params: params,
    responseType: 'blob'
  })
}


// 获取设置列表
export const getSettingsList = (only_visible) => {
  return request.get('/settings/get/settings', {
    params: {
      only_visible: only_visible || 0
    }
  })
}

// 更新设置
export const updateSettings = (id, data) => {
  return request.put(`/settings/update/settings/${id}`, {
    image_url: data.image_url,
    title: data.title,
    is_visible: data.is_visible
  })
}
